// extracted by mini-css-extract-plugin
export default {"container":"UserDetail_container__lw8ct","search-address-btn":"UserDetail_search-address-btn__UCr6t","groupBtn":"UserDetail_groupBtn__i7uy-"};